import React, { useContext } from "react";
import "./Img_modal.css";
import { Modal } from "react-bootstrap";
import { Context } from "../../../../utils/context";

function Img_modal({ ...props }) {
  console.log(props.image);

  const { IMG_URL } = useContext(Context);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Details_Modal View_Delivery_Boy_Details"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Delivery Boy Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="document_big_img_holder">
            <img src={`${IMG_URL}${props.image}`} alt="" className="big_img" />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Img_modal;
